import { api } from './../../system/api';

export default {
    list: () => api.get('/notice-stages'),
    update: (id, payload) => api.put(`/notice-stages/${id}`, payload),
    getActions: () => api.get('/notice-stages/actions')
};
